<template>
  <!-- <el-radio v-model="radio" label="1">好</el-radio>
  <el-radio v-model="radio" label="2">较好</el-radio>
  <el-radio v-model="radio" label="3">一般</el-radio>
  <el-radio v-model="radio" label="4">差</el-radio> -->
  <template v-for="(rate, index) in rates" :key="index">
    <el-radio v-model="radio" :label="index + 1">{{ rate }}</el-radio>
  </template>
</template>

<script>
export default {
  name: "RatioGroup",
  props: ["rateArr", "scoreArr"],
  data() {
    return {
      radio: 1,
      scores: this.scoreArr,
      rates: this.rateArr,
    };
  },

  watch: {
    radio(newVal, oldVal) {
      this.$emit("radio", this.scores[parseInt(this.radio) - 1]);
    },
  },
  created() {
    this.$emit("radio", this.scores[parseInt(this.radio) - 1]);
  },
  computed: {
    parseIntScore() {
      return parseInt(this.radio);
    },
  },
};
</script>

<style scoped lang="scss">
.el-radio {
  margin-right: 1px;
}
</style>